const translation: Record<string, string> = {
  // Navbar
  "nav.home": "Home",
  "nav.categories": "Categorie",
  "nav.itaobuy_sheet": "itaobuy sheet",
  "nav.buy_now": "buy it now",

  // Categories
  "cat.shoes": "Scarpe",
  "cat.hoodies": "Felpe/Maglioni",
  "cat.tshirts": "T-Shirt",
  "cat.jackets": "Giacche",
  "cat.pants": "Pantaloni/Corti",
  "cat.headwear": "Cappelli",
  "cat.sets": "Set",
  "cat.underwear": "Intimo",
  "cat.jersey": "Maglie Sportive",
  "cat.accessories": "Accessori",
  "cat.bags": "Borse",
  "cat.belts": "Cinture",
  "cat.perfumes": "Profumi",
  "cat.other": "Altro",

  // Hero
  "hero.tag": "Guida Aggiornata 2026",
  "hero.h1_line1": "Itaobuy Spreadsheet Italia:",
  "hero.h1_line2": "la guida completa per trovare,",
  "hero.h1_line3": "analizzare e organizzare prodotti online",
  "hero.subtitle": "Scopri tutto quello che devi sapere su Itaobuy Spreadsheet: come funziona, come scegliere le migliori liste, come confrontare prodotti e utilizzare informazioni aggiornate.",
  "hero.cta_primary": "Accedi alla guida Itaobuy Spreadsheet",
  "hero.cta_secondary": "Esplora tutte le categorie",
  "hero.trust_1": "Guide aggiornate 2026",
  "hero.trust_2": "Contenuti in italiano",
  "hero.trust_3": "Tabelle comparative",
  "hero.trust_4": "Informazioni indipendenti",

  // Problem/Solution
  "about.tag": "Cos'è Itaobuy Spreadsheet",
  "about.title_line1": "Il punto di riferimento italiano",
  "about.title_line2": "per guide, analisi e categorie",
  "about.title_line3": "su Itaobuy Spreadsheet",
  "about.problem_title": "Il problema",
  "about.problem_text": "Cercare manualmente prodotti online richiede molto tempo e molte informazioni disperse. Trovare il prodotto giusto al prezzo migliore può diventare frustrante senza gli strumenti adeguati.",
  "about.solution_title": "La soluzione",
  "about.solution_text": "Itaobuy Spreadsheet permette di organizzare informazioni, categorie e prodotti in modo semplice e strutturato, offrendoti un accesso rapido a dati aggiornati e confronti immediati.",

  // Features
  "features.subtitle": "Perché sceglierlo",
  "features.title": "I vantaggi di Itaobuy Spreadsheet",
  "features.card1_title": "Ricerca intelligente",
  "features.card1_desc": "Trova informazioni organizzate e strutturate per categoria, con filtri avanzati che ti permettono di individuare esattamente ciò che cerchi in pochi secondi.",
  "features.card2_title": "Confronto prodotti",
  "features.card2_desc": "Analizza alternative rapidamente con tabelle comparative chiare. Confronta prezzi, caratteristiche e disponibilità in un'unica vista ottimizzata.",
  "features.card3_title": "Risparmio tempo",
  "features.card3_desc": "Evita ricerche infinite su decine di siti. Con Itaobuy Spreadsheet hai tutto ciò che ti serve in un unico posto, organizzato e sempre aggiornato.",

  // Comparison Table
  "compare.title": "Itaobuy Spreadsheet vs Metodo Tradizionale",
  "compare.col_feature": "Caratteristica",
  "compare.col_itaobuy": "Itaobuy Spreadsheet",
  "compare.col_manual": "Ricerca manuale",
  "compare.row_org": "Organizzazione",
  "compare.row_speed": "Velocità",
  "compare.row_compare": "Confronto",
  "compare.row_updates": "Aggiornamenti",
  "compare.row_ux": "Esperienza utente",
  "compare.alta": "Alta",
  "compare.bassa": "Bassa",
  "compare.semplice": "Semplice",
  "compare.complesso": "Complesso",
  "compare.possibili": "Possibili",
  "compare.limitati": "Limitati",
  "compare.ottima": "Ottima",
  "compare.media": "Media",

  // Categories Section
  "categories.title": "Categorie Prodotti",
  "categories.subtitle": "Esplora tutte le categorie disponibili su Itaobuy Spreadsheet. Ogni categoria è organizzata per facilitare la tua ricerca e offrirti i migliori prodotti.",

  // Trust/Review
  "trust.label": "Cosa dicono di noi",
  "trust.quote": "\"Itaobuy Spreadsheet ha rivoluzionato il modo in cui organizzo i miei acquisti online. Finalmente un sistema chiaro per confrontare e scegliere.\"",
  "trust.author": "Marco R.",
  "trust.verified": "Verificato su Trustpilot",

  // CTA
  "cta.title": "Pronto a scoprire Itaobuy Spreadsheet?",
  "cta.subtitle": "Accedi subito alla piattaforma completa e inizia a organizzare i tuoi acquisti in modo intelligente.",
  "cta.button": "Visita Itaobuy Spreadsheet",

  // SEO Content Section
  "seo.section_title": "Itaobuy Spreadsheet: tutto quello che devi sapere",
  "seo.intro": "Nel mondo dello shopping online, trovare i prodotti giusti può richiedere ore di ricerca. Itaobuy Spreadsheet nasce per semplificare questo processo, offrendo un sistema organizzato di informazioni, categorie e confronti che ti permette di prendere decisioni di acquisto più informate e rapide.",
  "seo.h2_1": "Come funziona Itaobuy Spreadsheet",
  "seo.p1": "Itaobuy Spreadsheet è una piattaforma che organizza prodotti e categorie in formato tabellare, rendendo facile la navigazione tra migliaia di articoli. Il sistema è stato progettato per essere intuitivo: ogni categoria raggruppa prodotti simili, permettendoti di confrontare prezzi, caratteristiche e disponibilità in pochi secondi. A differenza della ricerca manuale su molteplici siti, Itaobuy Spreadsheet centralizza tutte le informazioni in un unico punto di accesso.",
  "seo.h2_2": "Categorie disponibili",
  "seo.p2": "Le categorie coprono una vasta gamma di prodotti: dalle Scarpe all'Abbigliamento, dagli Accessori ai Profumi. Ogni categoria è costantemente aggiornata con nuovi prodotti e informazioni. Puoi esplorare Sneakers, Streetwear, Felpe, Giacche, Pantaloni, Cappelli, Set completi, Intimo, Maglie sportive, Accessori moda, Borse, Cinture, Profumi e molto altro ancora. La struttura a categorie ti permette di trovare rapidamente ciò che cerchi senza perderti in ricerche infinite.",
  "seo.h2_3": "Perché usare Itaobuy Spreadsheet",
  "seo.p3": "Il vantaggio principale di Itaobuy Spreadsheet è la capacità di risparmiare tempo prezioso. Invece di navigare su decine di siti web diversi, puoi accedere a tutte le informazioni di cui hai bisogno da un'unica piattaforma organizzata. Le tabelle comparative ti aiutano a valutare le alternative, mentre gli aggiornamenti regolari garantiscono che i dati siano sempre attuali. Che tu stia cercando le ultime tendenze streetwear o prodotti di nicchia, Itaobuy Spreadsheet ti offre una visione completa e strutturata del mercato.",
  "seo.article_link": "Leggi la guida completa",

  // Footer
  "footer.brand_desc": "Il punto di riferimento italiano per guide, analisi e categorie su Itaobuy Spreadsheet. Informazioni aggiornate, confronti e consigli per organizzare i tuoi acquisti online.",
  "footer.quick_links": "Link Rapidi",
  "footer.categories_footer": "Categorie",
  "footer.resources": "Risorse",
  "footer.guide": "Guida Completa",
  "footer.faq": "Domande Frequenti",
  "footer.about": "Chi Siamo",
  "footer.contact": "Contatti",
  "footer.newsletter": "Rimani Aggiornato",
  "footer.newsletter_desc": "Iscriviti per ricevere guide, aggiornamenti e nuovi contenuti su Itaobuy Spreadsheet.",
  "footer.subscribe": "Iscriviti",
  "footer.email_placeholder": "La tua email",
  "footer.copyright": "© 2026 Itaobuy Spread. Tutti i diritti riservati.",

  // Article Page
  "article.back_home": "← Torna alla Home",
  "article.read_more": "Continua a leggere",
  "article.related": "Articoli Correlati",
  "article.share": "Condividi",
};

export default translation;